import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateAutoplayModuleForm, { type FormValues } from './UpdateAutoplayModuleForm';

type UpdateAutoplayModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdateAutoplayModuleDrawer = ({ moduleId, initialValues, visible, onClose }: UpdateAutoplayModuleDrawerProps) => {
    const { t } = useTranslation(['autoplayModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('autoplayModuleDetails:autoplayModuleDrawer.cancelButton')}</Button>
                    <Button form="updateAutoplayModule" htmlType="submit" type="primary">
                        {t('autoplayModuleDetails:autoplayModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('autoplayModuleDetails:autoplayModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateAutoplayModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateAutoplayModuleDrawer;

export const useUpdateAutoplayModuleDrawer = (
    moduleId: string,
    initialValues: UpdateAutoplayModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdateAutoplayModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
